<style lang="scss">
    .share-button {
        padding: 5px;
    }
</style>

<template>
    <a class="share-button" href="javascript:;" @click.stop="share()">
        <font-awesome-icon icon="share-alt"></font-awesome-icon>
        <slot name="label"></slot>
    </a>
</template>

<script>
    export default {
        props: ['item','parent'],
        computed: {
            shareModal() {
                return this.$store.state.shareModal
            }
        },
        methods: {
            share() {
                this.$store.commit("shareable", {shareable: this.item})
                this.$store.commit("shareFromPage", {shareFromPage: this.parent});

                if (this.shareModal) {
                    this.shareModal.modal('show')
                }
            },
        }
    }
</script>